import React, { forwardRef } from 'react';
import classnames from 'classnames';
import styles from './PrimaryButton.module.scss';
import lockSvg from '../../../assets/images/svg/lock-white.svg';
import { PrimaryButtonProps } from './types';

const PrimaryButton = forwardRef<HTMLButtonElement, PrimaryButtonProps>(
  (
    {
      onClick,
      title,
      isLoading = false,
      type = 'button',
      dataTestId = 'primary-button',
      isDisabled = false,
      className = '',
      isCompleteOrderOrProceedCheckout = false,
      id = '',
      buttonId = '',
      size = 'medium', 
    },
    ref,
  ) => (
    <button
      className={classnames('link-style--solid-dark', styles['primary-button'], className, 
        `btn--${size}`, {
        [styles.disabled]: isLoading,
      })}      
      disabled={isDisabled || isLoading}
      onClick={onClick}
      data-testid={dataTestId}
      data-buttonid={buttonId}
      // eslint-disable-next-line react/button-has-type
      type={type}
      id={id}
      ref={ref}
    >
      <div className={styles['button-elements']}>
        {!isLoading ? title : ''}
        {isLoading && !isDisabled ? <div className={styles.loader} /> : ''}
        {isCompleteOrderOrProceedCheckout && (
          <img src={lockSvg as unknown as string} alt="Padlock icon" />
        )}
      </div>
    </button>
  ),
);

export default PrimaryButton;
